if (!customElements.get('store-reviews')) {
  customElements.define(
    'store-reviews',
    class StoreReviews extends HTMLElement {
      constructor() {
        super();
        this.sectionID = this.dataset.sectionId;
        this.swiperNavigation = this.querySelector('[data-navigation]');
      }

      connectedCallback() {
        this.initSwiper();
        this.fetchReviews();
      }

      initSwiper() {
        // swiper element
        const swiperEl = this.querySelector('swiper-container');

        // swiper parameters
        const swiperParams = {
          slidesPerView: 1.25,
          spaceBetween: 16,
          navigation: {
            nextEl: this.querySelector(`.swiper-button-next-${this.sectionID}`),
            prevEl: this.querySelector(`.swiper-button-prev-${this.sectionID}`),
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          },
        };

        // now we need to assign all parameters to Swiper element
        Object.assign(swiperEl, swiperParams);

        // and now initialize it
        swiperEl.initialize();
      }

      async fetchReviews() {
        const response = await fetch(
          `https://api.reviews.io/reviews?store=${this.dataset.storeId}`
        );
        // Parse the JSON response
        const data = await response.json();
        // Destructure the data object
        const reviews = data.reviews;
        const swiperContainer = this.querySelector('swiper-container');
        // Get the review template
        const template = document.querySelector('[data-review-template]').content;

        // Create a slide for each review
        reviews.forEach((review) => {
          const slide = this.createReviewSlide(template, review);
          // swiperContainer.appendChild(slide);
          swiperContainer.swiper.appendSlide(slide);
        });

        reviews.length > 4 && this.swiperNavigation.classList.remove('!hidden');
      }

      /**
       * Creates a review slide from a template and review object.
       * @param {HTMLTemplateElement} template The template element to clone.
       * @param {Object} review The review object to use for the slide.
       * @returns {HTMLElement} The review slide element.
       **/
      createReviewSlide(template, review) {
        // Clone the template
        const slide = template.cloneNode(true);

        // Set the review data
        slide.querySelector('[data-review-name]').textContent = review.author.name;
        const starContainer = slide.querySelector('[data-review-score]');

        // Create a string of SVG elements to represent the review rating
        starContainer.innerHTML = [...Array(5)]
          .map((_, index) =>
            review.rating >= index + 1
              ? '<svg class="icon size-4" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m8 3 1.764 3.573 3.944.573-2.854 2.781.674 3.928L8 12l-3.527 1.855.673-3.928-2.853-2.781 3.943-.573z" fill="currentColor" stroke="currentColor" stroke-width="2"/></svg>'
              : '<svg class="icon size-4" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m8 3 1.764 3.573 3.944.573-2.854 2.781.674 3.928L8 12l-3.527 1.855.673-3.928-2.853-2.781 3.943-.573z" fill="none" stroke="currentColor" stroke-width="2"/></svg>'
          )
          .join('');

        // Set the review content
        slide.querySelector('[data-review-content]').textContent = review.comments;

        // Show the verified badge if the review is verified
        if (review.order_id) {
          slide.querySelector('[data-review-verified]').style.display = 'flex';
        }

        // Return the slide
        return slide;
      }
    }
  );
}

if (!customElements.get('average-score')) {
  customElements.define(
    'average-score',
    class AverageScore extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.fetchReviews();
      }

      /**
       * Fetches reviews from the Reviews.io API and updates the review elements on the page.
       * The Reviews.io 'Plus' plan is required to access the API, but only the store ID is needed.
       * @requires {string} this.dataset.storeId The store ID to fetch reviews for.
       * @returns {Promise<void>} A promise that resolves once the reviews are fetched and the elements are updated.
       */
      async fetchReviews() {
        try {
          const response = await fetch(
            `https://api.reviews.io/reviews?store=${this.dataset.storeId}`
          );
          // Parse the JSON response
          const data = await response.json();
          // Destructure the data object
          const { average_rating, review_count, verdict } = data;
          // Get the review elements
          const reviewScoreElement = this.querySelector('[data-review-score]');
          const reviewCountElement = this.querySelector('[data-review-count]');
          const reviewVerdictElement = this.querySelector('[data-review-verdict]');
          const reviewStarsElement = this.querySelector('[data-review-stars]');

          // Set the review score text
          reviewScoreElement.textContent = parseFloat(average_rating);
          // Set the review count text
          reviewCountElement.textContent = review_count;
          // Set the review verdict text
          reviewVerdictElement.textContent = verdict;
          // Create a string of SVG elements to represent the average rating
          reviewStarsElement.innerHTML = [...Array(5)]
            .map((_, index) =>
              average_rating >= index + 1
                ? `<svg class="icon size-4" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m8 3 1.764 3.573 3.944.573-2.854 2.781.674 3.928L8 12l-3.527 1.855.673-3.928-2.853-2.781 3.943-.573z" fill="currentColor" stroke="currentColor" stroke-width="2"/></svg>`
                : `<svg class="icon size-4" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m8 3 1.764 3.573 3.944.573-2.854 2.781.674 3.928L8 12l-3.527 1.855.673-3.928-2.853-2.781 3.943-.573z" fill="none" stroke="currentColor" stroke-width="2"/></svg>`
            )
            .join('');

          // Show the element if/once the data is fetched
          data && this.classList.replace('hidden', 'flex');
          // Log an error if the data is not fetched
        } catch (error) {
          console.error('Error fetching reviews:', error);
        }
      }
    }
  );
}
